/* =============================================================================
   CORE / DIALOG-LOGIC — Pure-Logik der styled In-App-Dialoge (S190)
   =============================================================================
   Projekt-Prinzip (Jonas 2026-07-01): NIE native window.prompt/confirm/alert —
   alles inline/styled in der App. Diese Pure-Helfer tragen die Entscheidungs-/
   Normalisierungs-Logik der Dialog-Komponente (views/ui/dialogs.js), damit sie
   ohne DOM testbar ist. Kein DOM/Storage.
============================================================================ */

/** Labels/Flags eines Confirm-Dialogs auffüllen (Defaults). */
export function confirmConfig(opts) {
  const o = opts || {};
  return {
    title: o.title || 'Bestätigen',
    body: o.body || '',
    danger: !!o.danger,
    confirmLabel: o.confirmLabel || (o.danger ? 'Löschen' : 'Bestätigen'),
    cancelLabel: o.cancelLabel || 'Abbrechen',
    reasonField: !!o.reasonField,
    reasonLabel: o.reasonLabel || 'Grund (optional)',
    reasonPlaceholder: o.reasonPlaceholder || 'optional — hilft beim späteren Audit',
    // challenge: der Nutzer muss diesen Text exakt tippen, damit „Bestätigen" aktiv wird
    challenge: (o.challenge != null && String(o.challenge) !== '') ? String(o.challenge) : null
  };
}

/** Labels/Flags eines Prompt-Dialogs (Einzel-Eingabe) auffüllen. */
export function promptConfig(opts) {
  const o = opts || {};
  return {
    title: o.title || 'Eingabe',
    label: o.label || '',
    value: o.value != null ? String(o.value) : '',
    placeholder: o.placeholder || '',
    confirmLabel: o.confirmLabel || 'OK',
    cancelLabel: o.cancelLabel || 'Abbrechen',
    required: o.required !== false   // Default: nicht-leer erzwingen
  };
}

/** Normalisiert einen optionalen Grund-Text (leer → null). */
export function normalizeReason(str) {
  const s = (str == null ? '' : String(str)).trim();
  return s === '' ? null : s;
}

/** Challenge-Abgleich (GDPR-Endbestätigung u.ä.): getrimmt, case-insensitiv. */
export function challengeMatches(input, expected) {
  if (expected == null || String(expected) === '') return true; // keine Challenge → immer ok
  return String(input || '').trim().toLowerCase() === String(expected).trim().toLowerCase();
}

/** Darf „Bestätigen" aktiv sein? (Challenge erfüllt + ggf. Pflicht-Eingabe da). */
export function canConfirm(cfg, state) {
  const c = cfg || {};
  const s = state || {};
  if (c.challenge) return challengeMatches(s.challengeInput, c.challenge);
  return true;
}

/** Prompt-Wert gültig? (required → nicht-leer). */
export function promptValueValid(cfg, value) {
  const c = cfg || {};
  const v = (value == null ? '' : String(value)).trim();
  return c.required ? v !== '' : true;
}
